export default {
  c1: '#3cfe7a',
  c2: '#b1f580',
  c3: '#fee633',
  c4: '#e07b29',
  c5: '#fe334e',
  c6: 'gray'
}
